export enum KpiOperation {
  AUTHENTICATE = 'authenticate',
  AUTHENTICATION_METHOD_LOOKUP = 'authenticationMethodsLookup',
  PAGE_LOAD = 'PAGE_LOAD',
  ADD_PASSKEY_BUTTON_CLICK = 'ADD_PASSKEY_BUTTON_CLICK',
  NOT_NOW_BUTTON_CLICK = 'NOT_NOW_BUTTON_CLICK',
  CONFIRM_BUTTON_CLICK = 'CONFIRM_BUTTON_CLICK',
  BACK_TO_MERCHANT_BUTTON_CLICK = 'BACK_TO_MERCHANT_BUTTON_CLICK',
  LEARN_MORE_OPEN_CLICK = 'LEARN_MORE_OPEN_CLICK',
  LEARN_MORE_CLOSE_CLICK = 'LEARN_MORE_CLOSE_CLICK'
}
